/* ================================================================
   Footer — Editorial refactor (magazine grid)
   Reference: ikoffice-de/Ilkwang Office Redesign.html · pages/home.jsx
   Preserves: i18n labels, all legal/business info, customer center
   ================================================================ */
import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../contexts/I18nContext";
import { BRAND } from "../config/brand";

export default function Footer() {
  const { t } = useI18n();
  const cols = [
    {
      h: "Shop",
      items: [
        { label: t.store || "스토어", to: "/store" },
        { label: t.rental || "렌탈", to: "/rental" },
        { label: "토너 · 소모품", to: "/store/toner-supplies" },
      ],
    },
    {
      h: "Service",
      items: [
        { label: t.inquiry || "견적 상담", to: "/consultation" },
        { label: "지역별 렌탈", to: "/rental" },
        { label: "A/S 신청", to: "/consultation?tab=service" },
        { label: t.compare || "제품 비교", to: "/compare" },
      ],
    },
    {
      h: "Company",
      items: [
        { label: t.sitemap || "사이트맵", to: "/sitemap" },
        { label: "이용약관", to: "/policy" },
        { label: "개인정보처리방침", to: "/policy" },
      ],
    },
  ];

  return (
    <footer
      style={{
        background: "var(--ink-900)",
        color: "rgba(255,255,255,0.5)",
        padding: "72px 0 32px",
        fontSize: 12,
        borderTop: "1px solid rgba(255,255,255,0.06)",
      }}
    >
      <div className="mob-pad-tight" style={{ maxWidth: 1240, margin: "0 auto", padding: "0 28px" }}>
        {/* Top grid */}
        <div
          className="r-footer-grid"
          style={{
            paddingBottom: 40,
            borderBottom: "1px solid rgba(255,255,255,0.06)",
          }}
        >
          {/* Brand */}
          <div>
            <Link
              to="/"
              style={{
                fontFamily: "var(--font-serif)",
                fontStyle: "italic",
                fontSize: 26,
                color: "white",
                letterSpacing: "-0.02em",
                fontWeight: 500,
              }}
            >
              {BRAND.logo}<span style={{ color: "var(--brand-400)" }}>.</span>
            </Link>
            <div style={{ marginTop: 18, lineHeight: 1.7 }}>
              일광엔시스 · 대표 강희성
              <br />
              경기도 안양시 동안구 시민대로 230 · A동403호
              <br />
              <a
                href="tel:1600-7542"
                style={{
                  color: "white",
                  fontSize: 22,
                  fontWeight: 700,
                  letterSpacing: "-0.01em",
                  display: "inline-block",
                  marginTop: 6,
                }}
              >
                1600-7542
              </a>
            </div>
            <div style={{ marginTop: 16, lineHeight: 1.7, fontSize: 11, color: "rgba(255,255,255,0.4)" }}>
              {t.footer_hours || "평일 09:00 - 18:00"}
              <br />
              {t.footer_lunch || "점심 12:00 - 13:00"}
              <br />
              <span style={{ opacity: 0.7 }}>{t.footer_holidays || "주말 · 공휴일 휴무"}</span>
            </div>
          </div>

          {/* Link columns */}
          {cols.map((c) => (
            <div key={c.h}>
              <div
                style={{
                  color: "white",
                  fontWeight: 600,
                  marginBottom: 14,
                  fontSize: 11,
                  letterSpacing: "0.12em",
                  textTransform: "uppercase",
                }}
              >
                {c.h}
              </div>
              <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 10 }}>
                {c.items.map((it) => (
                  <li key={it.label}>
                    <Link
                      to={it.to}
                      style={{ color: "rgba(255,255,255,0.55)", transition: "color 0.2s" }}
                      onMouseEnter={(e) => (e.currentTarget.style.color = "white")}
                      onMouseLeave={(e) => (e.currentTarget.style.color = "rgba(255,255,255,0.55)")}
                    >
                      {it.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Legal block */}
        <div style={{ marginTop: 24, fontSize: 11, color: "rgba(255,255,255,0.35)", lineHeight: 2 }}>
          <div
            style={{
              fontSize: 11,
              fontWeight: 600,
              color: "rgba(255,255,255,0.7)",
              letterSpacing: "0.08em",
              marginBottom: 6,
              textTransform: "uppercase",
            }}
          >
            Company Info
          </div>
          <div>
            <span style={{ color: "rgba(255,255,255,0.5)" }}>회사명</span>&nbsp;&nbsp;
            <span style={{ color: "rgba(255,255,255,0.7)" }}>일광엔시스</span>
            &nbsp;&nbsp;·&nbsp;&nbsp;
            <span style={{ color: "rgba(255,255,255,0.5)" }}>대표</span>&nbsp;&nbsp;강희성
            &nbsp;&nbsp;·&nbsp;&nbsp;
            <span style={{ color: "rgba(255,255,255,0.5)" }}>대표전화</span>&nbsp;&nbsp;1600-7542
            &nbsp;&nbsp;·&nbsp;&nbsp;
            <span style={{ color: "rgba(255,255,255,0.5)" }}>팩스</span>&nbsp;&nbsp;031-624-4769
          </div>
          <div>
            <span style={{ color: "rgba(255,255,255,0.5)" }}>주소</span>&nbsp;&nbsp;
            14067 경기도 안양시 동안구 시민대로 230 (관양동) 평촌아크로타워, A동403호
          </div>
          <div>
            <span style={{ color: "rgba(255,255,255,0.5)" }}>사업자등록번호</span>&nbsp;&nbsp;119-24-00329
            &nbsp;&nbsp;·&nbsp;&nbsp;
            <span style={{ color: "rgba(255,255,255,0.5)" }}>통신판매업신고</span>&nbsp;&nbsp;2019-안양동안-0517호
            &nbsp;&nbsp;·&nbsp;&nbsp;
            <a
              href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=1192400329"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-block",
                padding: "1px 8px",
                border: "1px solid rgba(255,255,255,0.2)",
                borderRadius: 4,
                color: "rgba(255,255,255,0.5)",
                fontSize: 10,
              }}
            >
              사업자정보확인
            </a>
          </div>
          <div>
            <span style={{ color: "rgba(255,255,255,0.5)" }}>개인정보관리책임자</span>&nbsp;&nbsp;
            강희성 master@sktec.kr
          </div>
        </div>

        {/* Bottom row */}
        <div
          style={{
            marginTop: 32,
            paddingTop: 20,
            borderTop: "1px solid rgba(255,255,255,0.06)",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 8,
            fontSize: 11,
            color: "rgba(255,255,255,0.3)",
          }}
        >
          <div>© {new Date().getFullYear()} {BRAND.name}. All rights reserved.</div>
          <div>Designed in Seoul · Issue №042</div>
        </div>
      </div>
    </footer>
  );
}
